/**
 * billingStatus.ts — Billing Phase 2
 * Overdue es un ESTADO DERIVADO de display, no un status persistido: una
 * invoice 'sent' cuyo dueDate ya pasó se muestra como 'overdue' en la UI,
 * pero la DB sigue diciendo 'sent'. Decisión deliberada: sin background job
 * que mute status, sin transición extra que deshacer si el dueDate se edita.
 * El backend acepta acciones sobre 'sent' (mark-paid, reminder) sin importar
 * si la UI la pinta como vencida.
 */

interface InvoiceStatusFields {
  status: string;
  dueDate: string | null;
}

export function isInvoiceOverdue(invoice: InvoiceStatusFields): boolean {
  if (invoice.status !== 'sent' || !invoice.dueDate) return false;
  return new Date(`${invoice.dueDate}T23:59:59`) < new Date();
}

// Status para display (pills, headers): igual al real salvo el caso derivado.
export function displayInvoiceStatus(invoice: InvoiceStatusFields): string {
  return isInvoiceOverdue(invoice) ? 'overdue' : invoice.status;
}

/** Días que una factura enviada puede pasar sin pagarse antes de pedir
 *  seguimiento. Espeja DIAS_FACTURA_VENCIDA en
 *  packages/server/src/services/navBadges.ts — si cambia allá, cambia acá, o
 *  el indicador del menú y la lista van a decir cosas distintas. */
const DIAS_PARA_SEGUIMIENTO = 7;

/**
 * ¿Esta factura pide que la persigas?
 *
 * Enviada, sin pagar, y con más de una semana encima. Cuenta desde que se
 * MANDÓ y no desde que se creó: un borrador de hace un mes no le debe nada a
 * nadie. Es el mismo criterio con el que el menú cuenta el badge de
 * Facturación, y es lo que marca la fila con la barra cian.
 */
export function necesitaSeguimiento(invoice: { status: string; sentAt: number | null; paidAt: number | null }): boolean {
  if (invoice.status !== 'sent' && invoice.status !== 'overdue') return false;
  if (invoice.paidAt != null || invoice.sentAt == null) return false;
  return invoice.sentAt + DIAS_PARA_SEGUIMIENTO * 86_400_000 <= Date.now();
}
